module.exports = __webpack_public_path__ + "static/media/collegeBoard.dded0f49.png";